(function () {
	'use strict';
	var controllerId = 'validazioneAccettaRifiuta';
	angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', 'richiesta', 'button', '$translate', '$filter', validazioneAccettaRifiutaFn]);

	function validazioneAccettaRifiutaFn($scope, $uibModalInstance, richiesta, button, $translate, $filter) {
		var msg = $translate.instant("ValidazioneRichiesta") + ": " + richiesta.Dipendente + " ";
		var s = "";
		var dtInizio = $filter('date')(richiesta.DtInizio, 'dd/MM/yyyy');
		var dtFine = "";
		var oraInizio = "";
		var oraFine = "";

		if (richiesta.DtInizio != richiesta.DtFine)
			dtFine = " - " + $filter('date')(richiesta.DtFine, 'dd/MM/yyyy');

		if (richiesta.OraInizio)
			oraInizio = " " + richiesta.OraInizio;
		if (richiesta.OraFine)
			oraFine = " - " + richiesta.OraFine;

		s = dtInizio + oraInizio + dtFine + oraFine + ' - ' + richiesta.Giustificativo;
		msg += s;

		$scope.domanda = msg;
		$scope.richiesta = richiesta;
		$scope.button = button;

		$scope.cancel = function () {
			var result = { stato: "annulla", richiesta: null };

			$uibModalInstance.close(result);
		};

		$scope.rifiuta = function () {
			var result = { stato: "rifiuta", richiesta: $scope.richiesta };

			$uibModalInstance.close(result);
		};
		$scope.ok = function () {
			var result = { stato: "approva", richiesta: $scope.richiesta };

			$uibModalInstance.close(result);
		}
	}
})();
